import { Slider } from "./slider.js";
import { SliderStyles, SliderTemplate } from "@fluentui/web-components";
import { DesignSystem } from "../design-system.js";
/**
 * The Fabric Slider component.
 *
 * @public
 */
export const definition = Slider.compose({
    name: `${DesignSystem.prefix}-slider`,
    template: SliderTemplate,
    styles: SliderStyles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=slider.definition.js.map